import React from 'react'
import { Box, Paper, Typography, alpha } from '@mui/material'
import type { EthicsStatusColor } from '../lib/formatEthicsSubmission'

type StatCardProps = {
  icon: React.ReactNode
  label: string
  value: number
  muiColor: EthicsStatusColor
}

export function StatCard({ icon, label, value, muiColor }: StatCardProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        p: 2.5,
        borderRadius: 3,
        border: '1px solid',
        borderColor: (theme) => alpha(theme.palette[muiColor].main, 0.15),
        bgcolor: (theme) => alpha(theme.palette[muiColor].main, 0.04),
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        minWidth: 160,
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: 2.5,
          bgcolor: (theme) => alpha(theme.palette[muiColor].main, 0.1),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: `${muiColor}.main`,
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography variant="h5" fontWeight={700} lineHeight={1.2}>{value}</Typography>
        <Typography variant="caption" color="text.secondary" fontWeight={500}>{label}</Typography>
      </Box>
    </Paper>
  )
}
